import React from 'react'

const menuButtonClass = 'hamburger hamburger--collapse menu-toggle'
const menuButtonActiveClass = 'hamburger hamburger--collapse menu-toggle is-active'

export class MenuToggle extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.handleClick = this.handleClick.bind(this)

    this.state = {
      isActive: false
    }
  }

  handleClick (e) {
    e.preventDefault()
    const sbc = document.querySelector('.sidebar-container')
    const mc = document.querySelector('.main-container')
    if (sbc && mc) {
      sbc.classList.toggle('pull-left-toggle')
      mc.classList.toggle('pull-left-toggle')
      this.setState({
        isActive: !this.state.isActive
      })
    }
  }

  render () {
    return (
      <button className={this.state.isActive ? menuButtonActiveClass : menuButtonClass} type='button' aria-label='menu' aria-controls='sidebarNav' onClick={this.handleClick}>
        <span className='hamburger-label'>Menu</span>
        <span className='hamburger-box'>
          <span className='hamburger-inner' />
        </span>
      </button>
    )
  }
}
